import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { UserServicePreference } from '../models'
import { Mapper } from './mapper.service'

import { UserApiService } from './user-api.service'

export interface UserServicePreferenceBulkUpdateParams {
  key: string
  scope: string
  scope_values?: string | null
  value: string | boolean | number | null
}

export interface UserServicePreferenceBulkUpdateResult {
  affected_user_ids: number[]
}

@Injectable({
  providedIn: 'root'
})
export class UserServicePreferenceService {

  constructor(private api: UserApiService) { }

  public findAll(): Observable<UserServicePreference[]> {
    return this.api.findAllAs<UserServicePreference>('preferences', {}, UserServicePreference)
  }

  public bulkUpdate(params: UserServicePreferenceBulkUpdateParams): Observable<UserServicePreferenceBulkUpdateResult> {
    return this.api.create<UserServicePreferenceBulkUpdateResult>('preferences/bulk_update', params)
  }

  public save(preference: UserServicePreference): Observable<UserServicePreference> {
    if (preference.id) {
      return this.api
        .update<UserServicePreference>(`preferences/${preference.id}`, preference)
        .pipe(map((result) => Mapper.as<UserServicePreference>(result, UserServicePreference)))
    } else {
      return this.api
        .create<UserServicePreference>('preferences', preference)
        .pipe(map((result) => Mapper.as<UserServicePreference>(result, UserServicePreference)))
    }
  }

  public destroy(preference: UserServicePreference): Observable<any> {
    return this.api.delete(`preferences/${preference.id}`)
  }
}
